import * as React from 'react';

const SvgFileFile = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M20 8V6.59L15.41 2H4v20h16V10h-2v10H6V4h8v4h6Z" })
);

export { SvgFileFile as default };
//# sourceMappingURL=FileFile.es.js.map
